import { Component } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { environment } from '../../environments/environment';
import { ActivatedRoute } from '@angular/router';
import { PostService } from '../services/post.service';
import { NgFor, NgIf } from '@angular/common';
import { StripHtmlAndConvertPipe } from '../strip-html-and-convert.pipe';
import { ImagePreviewComponent } from '../image-preview/image-preview.component';
import { SlicePipe } from '@angular/common';

@Component({
  selector: 'app-post-detail',
  standalone: true,
  imports: [TranslateModule, NgFor, StripHtmlAndConvertPipe, ImagePreviewComponent, NgIf, SlicePipe],
  templateUrl: './post-detail.component.html',
  styleUrl: './post-detail.component.css'
})
export class PostDetailComponent {

  baseApiUrl = environment.baseApiUrl;

  post: any;

  previewImage: string | null = null;

  constructor(private route: ActivatedRoute, private postService: PostService, private translate: TranslateService) {}

  ngOnInit(): void {
    const postId = Number(this.route.snapshot.paramMap.get('id'));
    if (postId) {
      this.postService.getPostById(postId).subscribe((res: any) => {
        this.post = res.data;
      })
    }
  }

   openPreview(imgUrl: string) {
    this.previewImage = imgUrl;
  }

  closePreview() {
    this.previewImage = null;
  }

  isKhmer(): boolean {
    return this.translate.currentLang === 'kh';
  }

  isEnglish(): boolean {
    return this.translate.currentLang === 'en';
  }

  get remainingFiles() {
    return this.post?.files?.slice(1) || [];
  }

}
